(ns hai-model.activity)

(def default-recency [7 :days])
(def default-active-threshold [5 :minutes])

(defn threshold->minutes [[value unit]]
  (case unit
    :minutes value
    :hours (* value 60)
    value))
